import { render, staticRenderFns } from "./cube_loading.vue?vue&type=template&id=6a711a87"
import script from "./cube_loading.vue?vue&type=script&lang=js"
export * from "./cube_loading.vue?vue&type=script&lang=js"
import style0 from "./cube_loading.vue?vue&type=style&index=0&id=6a711a87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports